import { jsxs as g, jsx as r } from "@emotion/react/jsx-runtime";
import { useRef as u } from "react";
import { Image as d } from "@partoohub/ui";
import { useImageWithFallback as p, ImageStatus as t } from "./hooks/useImageWithFallback.js";
import { ImageFallbackContainer as h, InitialDiv as S, DefaultImageLoader as b, StyledIcon as k } from "./ImageWithFallback.styled.js";
const W = ({
  resizeImageConfig: s,
  fallback: i,
  alt: c,
  title: l,
  shouldResize: m = !0,
  containerCss: n,
  loader: f = /* @__PURE__ */ r(b, { children: /* @__PURE__ */ r(k, { className: "fa-solid fa-circle-notch fa-spin" }) }),
  ...I
}) => {
  const e = u(null), {
    state: a,
    transformedSrc: o
  } = p(e, s, m);
  return /* @__PURE__ */ g(h, { ref: e, css: n, children: [
    a === t.Initial && /* @__PURE__ */ r(S, {}),
    a === t.Loading && f,
    a === t.Error && i,
    a === t.Success && o && /* @__PURE__ */ r(d, { src: o, alt: c ?? "", title: l, ...I })
  ] });
};
export {
  W as ImageWithFallback
};
